import {
  PICKUP,
  DROP,
  DROPS,
  BOOKING_DISTANCE,
  BOOKING_DURATION,
  CAR_TYPE,
  SELECTED_LOCATION,
  ESTIMATED_PRICES,
  AVAILABLE_CARS,
  BOOKING_SAVE,
  BOOKING_CANCEL,
  BOOKING_SCREEN_SIZE,
  BOOKING_DRIVER,
  CHECK_ZONE,
  CURRENT_RIDE_CHECK,
  CANCEL_REASONS,
  START_TRIP,
  STOP_TRIP,
  CHAT_MESSAGE_SEND,
  CHAT_MESSAGE_UPDATE,
  CHAT_OPEN_STATUS,
  SELECT_RIDE,
  NEW_CURRENT_RIDE,
  CLEAR_BOOKING,
  PAYMENT_CONFIRM_TRIP,
  CAR_EST_AMOUNT,
  BOOKING_DATA_UPDATE,
  RATING_SAVE,
  LATEST_RIDES,
  BOOKING_PAYMENT_TYPE,
  BOOKING_AMOUNTS,
  ZONE_PAY_GATEWAYS,
  PAYMENT_LIST_DESC,
  REFRESH_BOOKING,
  ROUTES_INFO,
  CAR_LIST,
  GUEST_SAVE,
  FETCH_CANNED_REPLIES,
  FETCH_EXTRA_CHARGES,
  DECIDE_EXTRA_CHARGE,
  FETCH_AMENDMENTS,
  REQUEST_AMENDMENT,
  FETCH_ADVANCES,
  DECIDE_ADVANCE,
  SET_BREAKDOWN_LINK,
  SET_DRIVER_LIVE_LOCATION,
  SET_DRIVER_TRAIL,
  SET_DRIVER_ETA,
  SET_PAYMENT_CONFIRMATION,
  SET_PAYMENT_CONFIRMATION_SEND,
  APPLY_TIP,
  ISSUE_SHARE_LINK,
  FETCH_RECENT_RIDES,
  AIRPORT_SERVICE,
  FLIGHT_NUMBER,
  FLIGHT_DATETIME,
  TERMINAL,
  TRUNK_LUGGAGE,
  HAND_LUGGAGE,
  AGENT_PROFILE,
} from 'App/store/constants';
import { MakeApiRequest } from 'App/common/Http';

// Fetch the logged-in agent's record (includes `default_location`). Returns the
// response promise so the caller can read data.default_location and geocode it.
export const getAgentDetails = (agentId: number | string) => {
  return MakeApiRequest({
    server: 'login',
    url: `agents/${agentId}`,
    method: 'GET',
    nextActionType: AGENT_PROFILE,
  });
};

export const checkCurrentRide = () => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/list/current/ride',
    method: 'GET',
    nextActionType: CURRENT_RIDE_CHECK,
  });
};

export const carTypeList = () => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'cartypes',
    method: 'GET',
    nextActionType: CAR_LIST,
  })
}

export const loadLatestRides = () => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/latest-rides`,
    method: 'GET',
    nextActionType: LATEST_RIDES,
  });
};

/*export const checkPickupZone = (data: any) => ({
  type: API_CALL,
  payload: {
    server: 'taxi',
    url: 'bookings/checkzone',
    method: 'POST',
    data: data,
    nextActionType: CHECK_ZONE,
  },
});*/


export const checkPickupZone = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/checkzone',
    method: 'POST',
    data: data,
    nextActionType: CHECK_ZONE,
  });
};

export const fetchAvailableCars = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'location/nearest-drivers',
    method: 'POST',
    data: data,
    nextActionType: AVAILABLE_CARS,
  });
};

export const fetchEstimatedPrices = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/estimate_price',
    method: 'POST',
    data: data,
    nextActionType: ESTIMATED_PRICES,
  });
};

export const saveBooking = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/save',
    method: 'POST',
    data: data,
    errorMsg: true,
    nextActionType: BOOKING_SAVE,
  });
};

export const saveGuestDetails = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: '/cust/guest-account-create',
    method: 'POST',
    data: data,
    errorMsg: true,
    nextActionType: GUEST_SAVE,
  });
};

export const fetchCancelReasons = (zoneId: number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `cancelreason/list/${zoneId}`,
    method: 'GET',
    nextActionType: CANCEL_REASONS,
  });
};

export const refreshBookingId = (id: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/refresh/id/${id}`,
    method: 'GET',
    nextActionType: REFRESH_BOOKING,
  });
};


export const cancelBooking = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/cancel',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: BOOKING_CANCEL,
  });
};

export const startTripDriver = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'driverbookings/start-trip',
    method: 'POST',
    data: data,
    nextActionType: START_TRIP,
  });
};

export const stopTripDriver = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'driverbookings/stop-trip',
    method: 'POST',
    data: data,
    nextActionType: STOP_TRIP,
  });
};

export const fetchBookingAmounts = (id: string | number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/booking-prices/' + id,
    method: 'GET',
    nextActionType: BOOKING_AMOUNTS,
  });
};

export const paymentConfirmDriver = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'driverbookings/payment-trip',
    method: 'POST',
    data: data,
    nextActionType: PAYMENT_CONFIRM_TRIP,
  });
};

export const zonePaymentGateways = (zoneId: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/payment-gateways/${zoneId}`,
    method: 'GET',
    nextActionType: ZONE_PAY_GATEWAYS,
  });
};

export const paymentGatewayDesc = () => {
  return MakeApiRequest({
    server: 'payment',
    url: 'gateway/payment-list-description',
    method: 'GET',
    nextActionType: PAYMENT_LIST_DESC,
  });
};

export const updatePaymentType = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/update/order',
    method: 'POST',
    data: data,
    nextActionType: BOOKING_PAYMENT_TYPE,
  });
};

export const saveRating = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'rating',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: RATING_SAVE,
  });
};

export const bookingDataUpdate = (data: any) => ({
  type: BOOKING_DATA_UPDATE,
  payload: data,
});

export const newCurrentRide = (data: any) => ({
  type: NEW_CURRENT_RIDE,
  payload: data,
});

export const clearBooking = () => ({
  type: CLEAR_BOOKING,
});

export const selectRide = (bookingId: number) => ({
  type: SELECT_RIDE,
  payload: bookingId,
});

export const saveChatMessage = (data: any) => ({
  type: CHAT_MESSAGE_SEND,
  payload: data,
});

export const fetchChatMessage = (data: any) => ({
  type: CHAT_MESSAGE_UPDATE,
  payload: data,
});

export const setChatOpenStatus = (isOpen: boolean) => ({
  type: CHAT_OPEN_STATUS,
  payload: isOpen,
});

export const setRoutesInfo = (data: any) => ({
  type: ROUTES_INFO,
  payload: data,
});

export const savePickup = (data: any) => ({
  type: PICKUP,
  payload: data,
});

//Old Func
export const saveDrop = (data: any) => ({
  type: DROP,
  payload: data,
});

//New Func
export const saveDrops = (data: any) => ({
  type: DROPS,
  payload: data,
});

export const saveDuration = (data: any) => ({
  type: BOOKING_DURATION,
  payload: data,
});

export const saveDistance = (data: any) => ({
  type: BOOKING_DISTANCE,
  payload: data,
});

export const saveCarType = (data: number) => ({
  type: CAR_TYPE,
  payload: data,
});

export const saveCarEstAmount = (data: number) => ({
  type: CAR_EST_AMOUNT,
  payload: data,
})

export const updateDriver = (data: any) => ({
  type: BOOKING_DRIVER,
  payload: data,
});

export const updateBookingScreenSize = (data: any) => ({
  type: BOOKING_SCREEN_SIZE,
  payload: data,
});

export const updateSelectedLocation = (data: any) => ({
  type: SELECTED_LOCATION,
  payload: data,
});

// REQUIREMENTS.md FR-2 — rider lifecycle for extra charges. The
// driver/admin add charges; the rider accepts/rejects (server enforces
// role on the decide route via requireRole('rider', 'admin')).
export const fetchExtraCharges = (bookingId: string | number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/extra-charges`,
    method: 'GET',
    nextActionType: FETCH_EXTRA_CHARGES,
  });
};

export const decideExtraCharge = (
  bookingId: string | number,
  chargeId: string | number,
  decision: 'accepted' | 'rejected',
  reason?: string,
) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/extra-charges/${chargeId}/decide`,
    method: 'POST',
    data: reason ? { decision, reason } : { decision },
    successMsg: true,
    errorMsg: true,
    nextActionType: DECIDE_EXTRA_CHARGE,
  });
};

// REQUIREMENTS.md FR-1 — rider amendment. List + request only on
// the rider side; the assigned driver decides via the mobile app.
export const fetchAmendments = (bookingId: string | number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/amendments`,
    method: 'GET',
    nextActionType: FETCH_AMENDMENTS,
  });
};

export const requestAmendment = (
  bookingId: string | number,
  newDrops: Array<{ lat: number; lon: number; add?: string }>,
  reason?: string,
) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/amend`,
    method: 'POST',
    data: { new_drops: newDrops, ...(reason ? { reason } : {}) },
    successMsg: true,
    errorMsg: true,
    nextActionType: REQUEST_AMENDMENT,
  });
};

// REQUIREMENTS.md FR-6 — rider sees driver-requested advances and
// taps Pay (decision='paid', payment_gateway/payment_ref) or Decline
// (decision='declined'). Cap is enforced server-side on request.
export const fetchAdvances = (bookingId: string | number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/advances`,
    method: 'GET',
    nextActionType: FETCH_ADVANCES,
  });
};

export const decideAdvance = (
  bookingId: string | number,
  advanceId: string | number,
  decision: 'paid' | 'declined',
  extras?: { payment_gateway?: string; payment_ref?: string },
) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/advance/${advanceId}/decide`,
    method: 'POST',
    data: { decision, ...(extras || {}) },
    successMsg: true,
    errorMsg: true,
    nextActionType: DECIDE_ADVANCE,
  });
};

// FR-3 — local action so rider's BreakdownBanner can deep-link to
// the re-booked ride. Reducer reads `previous_booking_id` off the
// booking_data_update payload; this is the explicit setter for
// scenarios where we need to clear or override (e.g. rider taps
// "View new booking" and we navigate away).
export const setBreakdownLink = (data: any) => ({
  type: SET_BREAKDOWN_LINK,
  payload: data,
});

// FR-10 — live driver location push from soc. The socket dispatches
// this on every `bookingMessageDriverLoc` arrival; MapRoute reads
// `state.booking.driverLiveLocation` and renders a moving marker.
// Payload from soc (see api/soc/routes/index.js):
//   { custId, type:'driver', location:[lon,lat], bookingStatus, bookingList, zone_id }
export const setDriverLiveLocation = (payload: any) => ({
  type: SET_DRIVER_LIVE_LOCATION,
  payload,
});

// PHASE 0 (#12) — trail + ETA, matching the mobile rider experience.
export const setDriverTrail = (payload: any) => ({
  type: SET_DRIVER_TRAIL,
  payload,
});

export const setDriverEta = (payload: any) => ({
  type: SET_DRIVER_ETA,
  payload,
});

// Payment method change → real-time driver update (parity with mobile).
// setPaymentConfirmation stores the method the driver screen should reflect
// (received both from the rider's own selection and the socket relay).
// setPaymentConfirmationSend is the broadcast trigger: the Socket layer
// watches it and emits `paymentTypeConfirmation` → soc relays to the driver.
export const setPaymentConfirmation = (payload: any) => ({
  type: SET_PAYMENT_CONFIRMATION,
  payload,
});

export const setPaymentConfirmationSend = (payload: any) => ({
  type: SET_PAYMENT_CONFIRMATION_SEND,
  payload,
});

// FR-13 #8 — apply rider tip on a completed booking. Server validates
// ownership + completed status; bumps tip_amount + tip_paid_at and
// fans out `tip.applied` so the driver app sees it.
export const applyTip = (bookingId: string | number, tip_amount: number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/tip`,
    method: 'POST',
    data: { tip_amount },
    successMsg: true,
    errorMsg: true,
    nextActionType: APPLY_TIP,
  });
};

// FR-13 #10 — request a 4h-signed share link for an active booking.
// Returns { url, token, expires_in }. Caller copies / shares the URL.
export const issueShareLink = (bookingId: string | number) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/${bookingId}/share-link`,
    method: 'POST',
    data: {},
    errorMsg: true,
    nextActionType: ISSUE_SHARE_LINK,
  });
};

// FR-13 #1 — recent unique rides for one-tap re-book carousel.
export const fetchRecentRides = (limit = 3) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `bookings/recent-rides?limit=${limit}`,
    method: 'GET',
    nextActionType: FETCH_RECENT_RIDES,
  });
};

// REQUIREMENTS.md FR-15 — canned chat reply library. Fetched on
// chat-open and whenever (role, zone, context) changes. Cached on
// the reducer slot so re-opens don't re-hit the network for the
// same bucket.
export const fetchCannedReplies = (params: {
  role: 'rider' | 'driver';
  context?: 'any' | 'active' | 'arrived' | 'started';
  zone_id?: number | string | null;
  language?: string;
}) => {
  const search = new URLSearchParams();
  search.set('role', params.role);
  if (params.context) search.set('context', params.context);
  if (params.zone_id != null && params.zone_id !== '') search.set('zone_id', String(params.zone_id));
  if (params.language) search.set('language', params.language);
  return MakeApiRequest({
    server: 'taxi',
    url: `canned-replies?${search.toString()}`,
    method: 'GET',
    nextActionType: FETCH_CANNED_REPLIES,
  });
};


// Airport Service Actions
export const saveAirportService = (data: boolean) => ({
  type: AIRPORT_SERVICE,
  payload: data,
});

export const saveFlightNumber = (data: string) => ({
  type: FLIGHT_NUMBER,
  payload: data,
});

export const saveFlightDateTime = (data: Date | null) => ({
  type: FLIGHT_DATETIME,
  payload: data,
});

export const saveTerminal = (data: any) => ({
  type: TERMINAL,
  payload: data,
});

export const saveTrunkLuggage = (data: number | string) => ({
  type: TRUNK_LUGGAGE,
  payload: data,
});

export const saveHandLuggage = (data: number | string) => ({
  type: HAND_LUGGAGE,
  payload: data,
});